const communication = {
    login: 'auth/login',
    logout: 'auth/logout',
    refreshToken: 'auth/refresh-tokens',
    getGroups: '/groups/get',
    getCoupons: '/coupon/getCoupon',
    getRegisterations: '/registration/get',
    updateRegisterations: '/registration/update',
    searchRegisterations: '/registration/search',
    getReports: '/reports/get',
    getBookings: '/bookings/get',
    issueMeetingLink: '/bookings/issue-link',
    executeQuery: '/reports/execute-query',
    certificates: "/certificates",
    getAllCertificatesTemplates: "/certificates/templates",
    getAllFonts: "/certificates/fonts",
    publishCertificate: (id) => `/certificates/${id}/publish`,
    unpublishCertificate: (id) => `/certificates/${id}/unpublish`,
    downloadCertificate: (id) => `/certificates/${id}/download`,
    emailCertificate: (id) => `/certificates/${id}/email`,
    users: {
        get: '/users/get',
        revoke: '/users/revoke'
    }



}

export default communication